import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import LineTitle from '../atoms/titles/LineTitle';
import Textlink from '../atoms/link/Textlink';
import LinkButton from '../atoms/button/LinkButton';
import RoomStateLabel from '../atoms/label/Label';
import Tag from '../atoms/tag/Tag';
import PriceBlock from '../molecules/PriceBlock';
import { makeQueryStringsWithDuplicatedSessionKey, makeAdditionalParamsPlanDetail } from '../../utils/queryParams';
import { BASENAME } from '../../constants';
import { usePrice } from '../../utils/price';

const FEMALE_TAG_ID = 'female_only';

const selector = (state) => ({
  flight: state.flight,
});

const PlanListView = ({ plans }) => {
  const { flight: flightState } = useSelector(selector);

  const {
    searchedFlightsInput, selectedOutboundFlight, selectedInboundFlight,
    fetchingOutbound, fetchingInbound, selectedOutboundDate
  } = flightState;

  const hidePrice = fetchingOutbound || fetchingInbound;
  const priceClassName = hidePrice ? 'hidden' : '';

  return (
    <div className="PlanList">
      {plans.map((p, index) => {
        const {
          id,
          name,
          stocks,
          recommendationPoint,
          roomType,
          hotel,
          tags: planTags,
          femaleOnlyPlan,
          mealCondition,
        }= p;

        const { id: roomTypeId } = roomType;

        const roomStateLittle = stocks < 7;
        const roomStateLabelColor = roomStateLittle ? 'red' : 'gray';
        const roomStateLabelText = roomStateLittle ? '空室わずか' : '空室あり';

        const { picsURL, tags: hotelTags } = hotel;
        const people= searchedFlightsInput && searchedFlightsInput.people;

        const planDetailParams = makeAdditionalParamsPlanDetail(id, roomTypeId);
        const search = makeQueryStringsWithDuplicatedSessionKey(planDetailParams);
        const planDetailLink = `${BASENAME}/plan_detail?${search}`;

        const handleClickButton = () => {
          const searchConfirm = makeQueryStringsWithDuplicatedSessionKey(planDetailParams);
          const entryConfirmLink = `${BASENAME}/entry_confirm?${searchConfirm}`;
          window.open(entryConfirmLink, '_blank');
        };

        const { totalPrice, pricePerAdult } = usePrice(people, selectedOutboundFlight, selectedInboundFlight, [p], selectedOutboundDate);

        const tags = [...hotelTags, ...planTags];

        if (femaleOnlyPlan) {
          const femaleTag = {
            id: FEMALE_TAG_ID,
            name: '女性限定',
            tagGroup: {},
          };

          tags.push(femaleTag);
        }

        return (
          <div key={`${id}-${roomTypeId}-${index}`} className="planListInner">
            <div className="header">
              <div className="headerLeft">
                <LineTitle>
                  <span className="planListLineTitle">{name}</span>
                  {/* https://gitlab.fqsv.net/dp-plus/front/issues/144 */}
                  {/* <span className="courseCode">［コースコード］{id}</span> */}
                </LineTitle>
              </div>
              <div className="headerRight">
                <Textlink size="sm" to={planDetailLink}>プラン詳細</Textlink>
              </div>
            </div>
            <div className="body">
              <div className="bodyLeft">
                <div className="thumbnailImage">
                  <img src={picsURL} alt="" />
                </div>
              </div>
              <div className="bodyRight">
                <p
                  className="text"
                  dangerouslySetInnerHTML={{ __html: recommendationPoint }}
                />
              </div>
            </div>
            <div className="footer">
              <div className="RecommendPlanLabel">
                <div className="recommendTagItems">
                  {tags && tags.map((t) => {
                    const { id, name, tagGroup } = t;
                    let colorType;
                    if (tagGroup.id === '2') {
                      colorType = 'purple';
                    }
                    if (tagGroup.id === '3') {
                      colorType = 'orange';
                    }
                    if (id === FEMALE_TAG_ID) {
                      colorType = 'pink';
                    }

                    return (
                      <div className="tagItem" key={id}>
                        <Tag colorType={colorType}>{name}</Tag>
                      </div>
                    );
                  })}
                  {mealCondition && (
                    <div className="tagItem">
                      <Tag colorType="orange">{mealCondition}</Tag>
                    </div>
                  )}
                </div>
                <div className="recommendLabel">
                  <RoomStateLabel color={roomStateLabelColor}>{roomStateLabelText}</RoomStateLabel>
                </div>
              </div>
              <div className="detail">
                <PriceBlock priceTotal={totalPrice} adultPrice={pricePerAdult} className={priceClassName} />
                <div className="action">
                  <LinkButton buttonType="cta" onClick={handleClickButton}>このプランを選択</LinkButton>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

PlanListView.propTypes = {
  plans: PropTypes.array.isRequired,
};

export default PlanListView;
